import { useMemo } from 'react';

const Pagination = ({ page, setPage, itemsPerPage, totalItems, className = '' }) => {
    const totalPages = useMemo(() => Math.ceil(totalItems / itemsPerPage), [itemsPerPage, totalItems]);

    return (
        <div className={`px-4 py-3 flex items-center justify-center sm:px-6 w-full ${className}`}>
            <div className="flex flex-col items-center justify-center">
                {totalPages > 1 && (
                    <div className="flex items-center justify-center">
                        <button
                            href="/"
                            className="hidden md:inline-flex relative items-center h-8 w-8 flex items-center justify-center text-sm hover:text-pink"
                            onClick={() => {
                                if (page - 1 > 0) setPage(page - 1);
                            }}
                        >
                            <span className="sr-only">Previous</span>
                            <svg
                                className="h-5 w-5"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                        </button>
                        <span className="py-2 px-4 sm:hidden">
                            {page}/{totalPages}
                        </span>
                        {page - 2 > 0 && (
                            <button
                                href="/"
                                className="hidden md:inline-flex relative items-center h-8 w-8 flex items-center justify-center text-sm hover:text-pink"
                                onClick={() => {
                                    if (page - 2 > 0) setPage(page - 2);
                                }}
                            >
                                {page - 2}
                            </button>
                        )}
                        {page - 1 > 0 && (
                            <button
                                href="/"
                                className="hidden md:inline-flex relative items-center h-8 w-8 flex items-center justify-center text-sm hover:text-pink"
                                onClick={() => {
                                    if (page - 1 > 0) setPage(page - 1);
                                }}
                            >
                                {page - 1}
                            </button>
                        )}
                        <button
                            href="/"
                            aria-current="page"
                            className="hidden md:inline-flex relative items-center h-8 w-8 flex items-center justify-center text-sm hover:text-pink border border-black rounded-lg"
                        >
                            {page}
                        </button>
                        {page + 1 <= totalPages && (
                            <button
                                href="/"
                                className="hidden md:inline-flex relative items-center h-8 w-8 flex items-center justify-center text-sm hover:text-pink"
                                onClick={() => {
                                    if (page + 1 > 0) setPage(page + 1);
                                }}
                            >
                                {page + 1}
                            </button>
                        )}
                        {page + 2 <= totalPages && (
                            <button
                                href="/"
                                className="hidden md:inline-flex relative items-center h-8 w-8 flex items-center justify-center text-sm hover:text-pink"
                                onClick={() => {
                                    if (page + 2 > 0) setPage(page + 2);
                                }}
                            >
                                {page + 2}
                            </button>
                        )}
                        <button
                            href="/"
                            className="hidden md:inline-flex relative items-center h-8 w-8 flex items-center justify-center text-sm hover:text-pink"
                            onClick={() => {
                                if (page + 1 > 0) setPage(page + 1);
                            }}
                        >
                            <span className="sr-only">Next</span>
                            <svg
                                className="h-5 w-5"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                        </button>
                    </div>
                )}
                {totalPages > 0 && (
                    <span className="hidden py-2 px-4 text-xs text-gray-darker sm:block">
                        {page}/{totalPages}
                    </span>
                )}
            </div>
        </div>
    );
};

export default Pagination;
